module.exports = __webpack_public_path__ + "img/logo.c318dbd1.jpg";